/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceName } from './ServiceName';
import {
    ServiceNameFromJSON,
    ServiceNameFromJSONTyped,
    ServiceNameToJSON,
} from './ServiceName';

/**
 * 
 * @export
 * @interface BackOfficeApiKeyRotateRequest
 */
export interface BackOfficeApiKeyRotateRequest {
    /**
     * 
     * @type {ServiceName}
     * @memberof BackOfficeApiKeyRotateRequest
     */
    service: ServiceName;
}



/**
 * Check if a given object implements the BackOfficeApiKeyRotateRequest interface.
 */
export function instanceOfBackOfficeApiKeyRotateRequest(value: object): value is BackOfficeApiKeyRotateRequest {
    if (!('service' in value) || value['service'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyRotateRequestFromJSON(json: any): BackOfficeApiKeyRotateRequest {
    return BackOfficeApiKeyRotateRequestFromJSONTyped(json, false);
}

export function BackOfficeApiKeyRotateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyRotateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'service': ServiceNameFromJSON(json['service']),
    };
}

export function BackOfficeApiKeyRotateRequestToJSON(value?: BackOfficeApiKeyRotateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'service': ServiceNameToJSON(value['service']),
    };
}

